export default __webpack_public_path__ + "static/media/settings.0ec029a1.svg";